/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountSigningKey.defs.js'
export * as $defs from './updateAccountSigningKey.defs.js'
